import type { ReactNode } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}